"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let Notifications = class Notifications extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_notification', { parameters: { state: 'new' } })
            .then(p => _.orderBy(p, ['created_at'], ['desc']));
    }
    ux;
    b_3343864469950044_style;
    dataMembers = ['items', 'ux', 'b_3343864469950044_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                ux: null,
                b_3343864469950044_style: {
                    overflow: "auto",
                },
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async evh_8697745105058001_click(event, scope) {
        return await this.actions.evh_8697745105058001_click.executeFromDOM(this, event, scope);
    }
    async act_1840158740026147_request_4060_getActionArgs($event) {
        return {
            operation: "update_notification",
            data: {
                id: $event.scope.item.id,
                etag: $event.scope.item.etag,
                state: 'handled',
                result_notes: this.notes,
            },
        };
    }
    async evh_1840158740026147_click(event, scope) {
        return await this.actions.evh_1840158740026147_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_4056 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_4055 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_4056,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_4055],
        });
        const act_8697745105058001_reloadComponentData_4058 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_8697745105058001_click_4057 = new core_1.actions.EventHandlerImpl({
            action: act_8697745105058001_reloadComponentData_4058,
            event: "click",
            displayName: "reload",
        });
        const evh_8697745105058001_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8697745105058001_click_4057],
        });
        const act_1840158740026147_reloadComponentData_4062 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_1840158740026147_success_4061 = new core_1.actions.EventHandlerImpl({
            action: act_1840158740026147_reloadComponentData_4062,
            event: "success",
            displayName: "reloadComponentData",
        });
        const act_1840158740026147_request_4060 = new core_1.actions.RequestAction({
            actionArgs: this.act_1840158740026147_request_4060_getActionArgs,
            displayName: "markRead",
            events: [evh_1840158740026147_success_4061],
        });
        const evh_1840158740026147_click_4059 = new core_1.actions.EventHandlerImpl({
            action: act_1840158740026147_request_4060,
            event: "click",
            displayName: "markRead",
        });
        const evh_1840158740026147_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1840158740026147_click_4059],
        });
        return {
            act_7315092382398562_reloadComponentData_4056,
            evh_7315092382398562_reload_4055,
            evh_7315092382398562_reload,
            act_8697745105058001_reloadComponentData_4058,
            evh_8697745105058001_click_4057,
            evh_8697745105058001_click,
            act_1840158740026147_reloadComponentData_4062,
            evh_1840158740026147_success_4061,
            act_1840158740026147_request_4060,
            evh_1840158740026147_click_4059,
            evh_1840158740026147_click,
            reload: act_8697745105058001_reloadComponentData_4058,
            markRead: act_1840158740026147_request_4060,
        };
    }
};
Notifications = __decorate([
    (0, vue_property_decorator_1.Component)()
], Notifications);
exports.default = Notifications;
vue_property_decorator_1.Vue.component("Notifications", Notifications);
